import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=04f5049f&scoped=true"
import script from "./NumberView.vue?vue&type=script&lang=js"
export * from "./NumberView.vue?vue&type=script&lang=js"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=04f5049f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f5049f",
  null
  
)

export default component.exports